
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import { translate, statusColor } from "@/core/services/HelpersFun";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import UserAvatar from "@/components/UserAvatar.vue";
import FileViewer from "@/components/FileViewer.vue";
import { ElNotification } from "element-plus/es";

export default defineComponent({
  name: "kt-otp-management-table",
  components: { UserAvatar, FileViewer },
  props: {
    widgetClasses: String,
  },
  setup() {
    const loading = ref(true);
    const list = ref();
    const pagination = ref();
    const mobile = ref();
    const page = ref(1);

    const getItems = () => {
      loading.value = true;
      ApiService.query("/admin/message/restricted-message", {
        params: { page: page.value },
      })
        .then(({ data }) => {
          loading.value = false;
          console.log(data.data);
          list.value = data.data.restricted_messages;
          pagination.value = data.data.restricted_messages.pagination;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const restricted_action = (type, id) => {
      loading.value = true;

      if (type === "reject") {
        document.getElementById("r-btn" + id)?.setAttribute("disabled", "true");
      } else {
        document.getElementById("btn" + id)?.setAttribute("disabled", "true");
      }

      ApiService.post(
        "/admin/message/restricted-message/" + id + "/" + type,
        {}
      )
        .then(() => {
          getItems();
          loading.value = false;
          ElNotification({
            title: translate("success"),
            message: "عملیات با موفقیت انجام شد.",
            type: "success",
          });
        })
        .catch(() => {
          loading.value = false;
        })
        .finally(() => {
          if (type === "reject") {
            document.getElementById("r-btn" + id)?.removeAttribute("disabled");
          } else {
            document.getElementById("btn" + id)?.removeAttribute("disabled");
          }
        });
    };

    const handleSizeChange = (val: number) => {
      return;
    };

    const handleCurrentChange = (val: number) => {
      page.value = val;
      getItems();
    };

    onMounted(() => {
      getItems();
      setCurrentPageBreadcrumbs(translate("پیام های نیاز به بررسی"), []);
    });

    return {
      loading,
      pagination,
      getItems,
      translate,
      statusColor,
      mobile,
      list,
      handleSizeChange,
      handleCurrentChange,
      restricted_action,
    };
  },
});
